// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleTicketCreator = {
  id: "ticket-creator",
  mrn: "//iam.api.mondoo.app/roles/ticket-creator",
  title: "Ticket Creator",
  allowedActions,
} as const;

export type RoleTicketCreator = typeof roleTicketCreator;
